<template>
  <div v-show="!empty">
    <div class="recent-holder" v-if="showing" ref="tholder">
      <div class="close-box small grey" v-on:click="hideMe" v-show="visible"></div>
      <transition name="fade">
        <div v-show="visible" class="fullwidth slim">
          <az-browse-panel :artists="artists" :title="$nippets.recentlyViewed" />
        </div>
      </transition>
    </div>
    <div class="recent-button" v-if="!showing && mwidth > 640">
      <div class="vertical-button" v-on:click="showMe">{{ $nippets.recentlyViewed }}</div>
    </div>
  </div>
</template>

<script>
import AzBrowsePanel from '@/components/panels/AzBrowsePanel.vue'
import MeasurablePage from '@/mixins/MeasurablePage.js'
export default {
  mixins: [MeasurablePage],
  components: {
    AzBrowsePanel
  },
  data () {
    return {
      showing: false,
      visible: false,
      artists: [],
      loaded: false
    }
  },
  computed: {
    empty () {
      return this.$store.getters.recents.length < 1
    }
  },
  methods: {
    async showMe() {
      if(!this.loaded) {
        this.artists = await this.$store.getters.recents
      }
      this.showing = true
      this.visible = true
      this.$k.sendGaEvent('RecentlyViewed','Clicked', this.$route.path)
    },
    async hideMe() {
      this.visible = false
      await this.$k.waitfor(200)
      this.showing = false
    }
  }
}
</script>

<style scoped>
.recent-holder{
  position:fixed;
  bottom:0;
  left:0;
  z-index:45;
  width:100%;
  box-sizing:border-box;
}

.recent-button .vertical-button{
  transform: rotate(-90deg);
  color:#fff;
  background-color:#98b8ad;
  position:fixed;
  right:11px;
  top:calc(95vh - 320px);
  padding:3px 15px 3px 39px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  font-size:16px;
  z-index:51;
  transform-origin: center right;
  background-image:url('../../assets/img/plus-button.svg');
  background-size:16px 16px;
  background-position:12px 50%;
  cursor:pointer;
}

.recent-button .vertical-button:hover{
  background-color:#ce0e2d;
}

.fullwidth.slim{
  padding-top:10px;
  padding-bottom:10px;
  background-color:#fff;
}

@media screen and (max-width:767px){
  .recent-button .vertical-button{
    display:none;
  }
  .recent-holder, .recent-button{
    display:none;
  }
}
</style>